export enum Sex {
  FEMALE = 'female',
  MALE = 'male',
}
  
export interface Person {
  firstName: string | null;
  lastName: string | null;
  sex: Sex;
}
  
export interface Rank {
  instructor: RankInstructor | null;
  scout: RankScout | null;
}

export enum RankInstructor {
  RANK_1 = 'rank1',
  RANK_2 = 'rank2',
  RANK_3 = 'rank3',
}
export const instructorRanks = Object.values(RankInstructor);
export const instructorRankNames = {
  [Sex.FEMALE]: {
    [RankInstructor.RANK_1]: 'przewodniczka',
    [RankInstructor.RANK_2]: 'podharcmistrzyni',
    [RankInstructor.RANK_3]: 'harcmistrzyni',
  },
  [Sex.MALE]: {
    [RankInstructor.RANK_1]: 'przewodnik',
    [RankInstructor.RANK_2]: 'podharcmistrz',
    [RankInstructor.RANK_3]: 'harcmistrz',
  },
};

export enum RankScout {
  RANK_1 = 'rank1',
  RANK_2 = 'rank2',
  RANK_3 = 'rank3',
  RANK_4 = 'rank4',
  RANK_5 = 'rank5',
  RANK_6 = 'rank6',
}
export const scoutRanks = Object.values(RankScout);
export const scoutRankNames = {
  [Sex.FEMALE]: {
    [RankScout.RANK_1]: ['ochotniczka', 'och.'],
    [RankScout.RANK_2]: ['tropicielka', 'trop.'],
    [RankScout.RANK_3]: ['pionierka', 'pion.'],
    [RankScout.RANK_4]: ['samarytanka', 'sam.'],
    [RankScout.RANK_5]: ['harcerka orla', 'HO'],
    [RankScout.RANK_6]: ['harcerka rzeczypospolitej', 'HR'],
  },
  [Sex.MALE]: {
    [RankScout.RANK_1]: ['młodzik', 'mł.'],
    [RankScout.RANK_2]: ['wywiadowca', 'wyw.'],
    [RankScout.RANK_3]: ['odkrywca', 'odkr.'],
    [RankScout.RANK_4]: ['ćwik', 'ćw.'],
    [RankScout.RANK_5]: ['harcerz orli', 'HO'],
    [RankScout.RANK_6]: ['harcerz rzeczypospolitej', 'HR'],
  },
};
